import { t } from "./i18n";
export const LOCATION_OPTIONS = [
  { value: "basement", label: t("Basement"),
    synonyms: ["basement", "cellar", "downstairs", "lower level", "under ground", "below grade"] },
  { value: "first_floor", label: t("First floor"),
    synonyms: ["first floor", "first", "ground floor", "main floor", "main level", "one"] },
  { value: "second_floor", label: t("Second floor"),
    synonyms: ["second floor", "second", "upstairs", "upper floor", "second level", "two"] },
  { value: "bedroom", label: t("Bedroom"),
    synonyms: ["bedroom", "bed room", "master bedroom", "kids room", "sleeping"] },
  { value: "living_area", label: t("Living area"),
    synonyms: ["living area", "living room", "family room", "den", "great room", "common area"] },
  { value: "crawl_space", label: t("Crawl space"),
    synonyms: ["crawl space", "crawlspace", "crawl", "sub floor"] },
  { value: "other", label: t("Other"),
    synonyms: ["other", "somewhere else", "elsewhere", "attic", "garage"] },
];

export const DEVICE_OPTIONS = [
  { value: "short_term_kit", label: t("Short-term test kit"),
    synonyms: ["short term", "short-term", "short term kit", "charcoal", "two day", "three day", "four day", "seven day", "activated charcoal"] },
  { value: "long_term_kit", label: t("Long-term (90-day) kit"),
    synonyms: ["long term", "long-term", "long term kit", "ninety day", "90 day", "alpha track", "alpha-track", "three month", "six month", "one year"] },
  { value: "continuous_monitor", label: t("Continuous radon monitor"),
    synonyms: ["continuous", "continuous monitor", "digital", "digital monitor", "electronic", "radon eye", "airthings", "corentium"] },
  { value: "professional_test", label: t("Professional test"),
    synonyms: ["professional", "professional test", "pro test", "inspector", "contractor test", "licensed"] },
  { value: "other", label: t("Other"),
    synonyms: ["other", "something else", "different"] },
];

export const KIND_OPTIONS = [
  { value: "screening", label: t("Screening"),
    synonyms: ["screening", "screen", "initial", "first test", "first", "starting"] },
  { value: "confirmatory", label: t("Confirmatory"),
    synonyms: ["confirmatory", "confirmation", "confirm", "verify", "second test"] },
  { value: "follow_up", label: t("Follow-up"),
    synonyms: ["follow up", "follow-up", "followup", "retest", "re test"] },
  { value: "post_mitigation", label: t("Post-mitigation"),
    synonyms: ["post mitigation", "post-mitigation", "after mitigation", "after fix", "after repair", "after fan", "post"] },
  { value: "long_term", label: t("Long-term monitoring"),
    synonyms: ["long term", "long-term", "long term monitoring", "monitoring", "ongoing", "yearly"] },
];

export const LABEL_LOOKUP = (options, value) =>
  options.find((o) => o.value === value)?.label || value;

export const LEVEL_STYLES = {
  "below-action": { bg: "#EAF1ED", border: "#6B9080", text: t("#2E5B4C") },
  "consider":     { bg: "#FCF3DC", border: "#D6A73B", text: t("#7A5A0F") },
  "action":       { bg: "#FBE6DF", border: "#E07A5F", text: t("#7A2E22") },
  "high":         { bg: "#F8D9D1", border: "#B34838", text: t("#5C2018") },
  "very-high":    { bg: "#EBBDB4", border: "#7A2E22", text: t("#3E1109") },
};
